import type { OrderStatus, PaymentMethod, ProductKind, StockReason } from '@growup/site-shared';
import type { StatusTone } from '@growup/ui';

const euro = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' });

export const formatEuros = (cents: number) => euro.format(cents / 100);

/** `12,50` or `12.5` → 1250. `null` when it is not a price. */
export function parseEuros(text: string): number | null {
  const clean = text.trim().replace(/\s|€/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(clean)) return null;
  return Math.round(Number(clean) * 100);
}

export const centsToInput = (cents: number) => (cents / 100).toFixed(2).replace('.', ',');

export const STATUS_LOOK: Record<OrderStatus, { label: string; tone: StatusTone }> = {
  pending_payment: { label: 'Por pagar', tone: 'warning' },
  paid: { label: 'Paga', tone: 'success' },
  delivered: { label: 'Entregue', tone: 'neutral' },
  cancelled: { label: 'Cancelada', tone: 'danger' },
};

export const PAYMENT_LABEL: Record<PaymentMethod, string> = {
  mbway: 'MB WAY',
  multibanco: 'Multibanco',
  card: 'Cartão',
  cash: 'Dinheiro',
};

export const KIND_LABEL: Record<ProductKind, string> = {
  merch: 'Merchandising',
  apparel: 'Roupa (tamanhos)',
  membership_fee: 'Quota de associado',
};

export const REASON_LABEL: Record<StockReason, string> = {
  restock: 'Entrada',
  adjustment: 'Acerto',
  order: 'Encomenda',
  order_cancelled: 'Cancelada',
};
